<template>
  <div class="volume-panel">
    <div class="mute-control" @click="toggle">
      <i v-if="muted || value === 0" class="iconfont icon-shengyinguanbi"></i>
      <i v-else class="iconfont icon-shengyinkaiqi"></i>
    </div>
    <div class="volume-control" :class="{ dragging }">
      <div ref="volumeBar" class="volume-bar" @mousedown="onMouseDown">
        <div class="volume-level" :style="`width: ${muted ? 0 : value * 100}%`">
          <span class="control-text"></span>
        </div>
      </div>
      <div class="current-volume-tooltip">
        当前音量：<b>{{ (value * 100).toFixed(0) }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import * as throttle from 'lodash/throttle'

export default {
  props: {
    value: {
      type: Number,
      default: 0.5
    },
    muted: Boolean
  },
  data() {
    return {
      dragging: false
    }
  },
  methods: {
    onMouseDown(e) {
      if (e.button === 0) {
        const bar = e.currentTarget
        const onMouseUp = me => {
          onMouseMove(me)
          onMouseMove.flush()
          document.body.removeEventListener('mouseup', onMouseUp)
          document.body.removeEventListener('mousemove', onMouseMove)
          this.$nextTick(() => {
            this.dragging = false
          })
        }
        const onMouseMove = throttle(me => {
          this.dragging = true
          const offset = me.clientX - bar.getBoundingClientRect().x
          const result =
            offset < 0 ? 0 : offset > bar.offsetWidth ? bar.offsetWidth : offset
          if (result > 0) {
            this.unmute()
          }
          this.$emit('change', result / bar.offsetWidth)
        }, 10)
        document.body.addEventListener('mouseup', onMouseUp)
        document.body.addEventListener('mousemove', onMouseMove)
      }
    },
    toggle() {
      this.$emit('update:muted', !this.muted)
    },
    mute() {
      this.$emit('update:muted', true)
    },
    unmute() {
      this.$emit('update:muted', false)
    }
  }
}
</script>

<style scoped lang="scss">
.volume-panel {
  display: inline-block;
  height: 100%;
  overflow: hidden;
  .mute-control {
    display: inline-block;
    margin-right: 8px;
    cursor: pointer;
    i {
      font-size: 20px;
    }
  }
  .volume-control {
    width: 56px;
    display: inline-block;
    vertical-align: middle;
    margin-top: -5px;
    margin-right: 20px;
    &:hover,
    &.dragging {
      .current-volume-tooltip {
        top: -20px;
        opacity: 1;
        visibility: visible;
      }
    }
  }
  .volume-bar {
    background-color: rgba(255, 255, 255, 0.45);
    height: 2px;
    cursor: pointer;
    position: relative;
  }
  .volume-level {
    position: absolute;
    height: 100%;
    background-color: #3352fe;
    left: 0;
    top: 0;
    &:after {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #ffffff;
      top: 50%;
      right: -5px;
      margin-top: -5px;
      cursor: pointer;
    }
  }
  .current-volume-tooltip {
    position: absolute;
    //top: -20px;
    top: -10px;
    height: 28px;
    line-height: 28px;
    padding: 0 12px;
    background-color: #363636;
    font-size: 12px;
    border-radius: 3px;
    margin-left: -20px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in;
    b {
      color: #f8633b;
    }
  }
}
</style>
